<!-- <app-s-table aria-label="NotificationRules" role="table" [sTableOptions]="notiTableOptions" *ngIf="!addEditRules"
             (filterCallback)="rulefilterCall($event)" (actionCallback)="ruleactionCall($event)"
             (refreshCallback)="getNotificationRulesData()"
             (pageCallback)="rulepageCall($event)" (addCallback)="ruleaddTableData()"
             (timerCallback)="getNotificationRulesData()"></app-s-table> -->
      <div *ngIf="!addEditRules">
        <mat-card>
          <mat-toolbar>
            <div class="table-tools">
              <button mat-stroked-button color="primary" (click)="ruleaddTableData()" class="" matTooltip="Add Rules">
                <mat-icon class="mat-18 mb-1">add</mat-icon> Add
              </button>
            </div>
            <div class="search-tools text-right" style="align-items: baseline !important;">
              <mat-form-field class="px-16 mr-3" style="font-size: medium !important;">
                <input matInput #filter placeholder="Search..." [(ngModel)]="searchInput">
                <button class="gray" matSuffix mat-icon-button color="primary" >
                  <mat-icon>search</mat-icon>
                </button>
                <!-- <mat-icon matSuffix>search</mat-icon> -->
              </mat-form-field>
              <button mat-stroked-button color="primary" (click)="getAutoMailData()" class="mt-20" matTooltip="Refresh Table">
                <mat-icon class="mat-18 mb-1">refresh</mat-icon>
              </button>
            </div>
          </mat-toolbar>
          <mat-card-content>
            <table mat-table [dataSource]="rowData | searchFilter: 'reconName':filter.value" class="">
              <ng-container matColumnDef="Recon Name" sticky>
                <th mat-header-cell *matHeaderCellDef>Recon Name</th>
                <td mat-cell *matCellDef="let rowData"> {{rowData.reconName}} </td>
              </ng-container>
            
              <ng-container matColumnDef="Sub Recon">
                <th mat-header-cell *matHeaderCellDef> Sub Recon </th>
                <td mat-cell *matCellDef="let rowData">{{rowData.subRecon}}</td>
              </ng-container>
            
              <ng-container matColumnDef="Mail Time">
                <th mat-header-cell *matHeaderCellDef> Mail Time </th>
                <td mat-cell *matCellDef="let rowData"><p *ngIf="rowData.schedulerEnabled === true">{{rowData.scheduler.hours + 'H'}}:{{rowData.scheduler.minutes + 'M'}}</p></td>
              </ng-container>
        
              <ng-container matColumnDef="Unit Name">
                <th mat-header-cell *matHeaderCellDef> Unit Name </th>
                <td mat-cell *matCellDef="let rowData"> {{rowData.unit}} </td>
              </ng-container>
        
              <ng-container matColumnDef="Time Delta">
                <th mat-header-cell *matHeaderCellDef> Time Delta </th>
                <td mat-cell *matCellDef="let rowData"> {{rowData.deltadateSelected}} </td>
              </ng-container>
        
              <ng-container matColumnDef="Manual Trigger">
                <th mat-header-cell *matHeaderCellDef> Manual Trigger </th>
                <td mat-cell *matCellDef="let rowData"> 
                  <button (click)="modalService.open('autoTriggerStmtDate'); autoMail(rowData)" class="mat-icon-button"><mat-icon text-center> email</mat-icon></button>    
                </td>
              </ng-container>
        
              <ng-container matColumnDef="Auto Trigger">
                <th mat-header-cell *matHeaderCellDef>Auto Trigger</th>
                <td mat-cell *matCellDef="let rowData"> 
                  <span *ngIf="rowData.autoTrigger === true">Yes</span>
                  <span *ngIf="rowData.autoTrigger === false">No</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="Is Active">
                <th mat-header-cell *matHeaderCellDef>Is Active</th>
                <td mat-cell *matCellDef="let rowData; let i = index"> 
                  <div class="ml-2 mb-2 d-flex flex-row alight-item-center">
                    <mat-slide-toggle id="{{rowData._id}}" (change)="changeHoldOption(rowData, $event)" [matTooltip]="rowData.isActive === true ? 'Yes' : 'No'" name="{{rowData._id}}" [(ngModel)]="rowData.isActive">
                    </mat-slide-toggle>
                  </div>
                  <!-- <span *ngIf="rowData.isActive === true">Yes</span>
                  <span *ngIf="rowData.isActive === false">No</span> -->
                </td>
              </ng-container>
              <ng-container matColumnDef="Integrations">
                <th mat-header-cell *matHeaderCellDef>Integrations</th>
                <td mat-cell *matCellDef="let rowData"> {{rowData.integration}} </td>
              </ng-container>
              <ng-container matColumnDef="Actions" stickyEnd>
                <th class="color1" mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell class="color1" *matCellDef="let rowData"> 
                  <button class="mat-icon-button mat-primary" mat-button [matMenuTriggerFor]="menu">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-button class="mat-menu-item" (click)="editData(rowData)" matTooltip="Edit">
                      <mat-icon>edit</mat-icon> Edit
                    </button>
                    <button mat-button class="mat-menu-item" (click)="deleteRuleConfirmationDialog(rowData)" matTooltip="Delete">
                      <mat-icon>delete</mat-icon> Delete
                    </button>
                  </mat-menu>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="headerColumns"></tr>
              <tr mat-row *matRowDef="let rowData; columns: headerColumns;"></tr>
            </table>
            <p class="p-4 ml-2" *ngIf="rowData && rowData.length === 0">
              <span>
                No data available!
              </span>
            </p>
          </mat-card-content>
        </mat-card>     
      </div>
  <ng-container *ngIf="addEditRules">
    <mat-card>
      <button class="position-absolute r-1p mt--10" aria-label="close modal icon" matTooltip="Close"
              (click)="addEditRules = !addEditRules;" mat-icon-button="">
        <mat-icon>close</mat-icon>
      </button>
      <mat-card-header>
        <mat-card-title>Manage Alert Notification Rules</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-card class="mb-20">
          <form #mailerForm="ngForm">
            <div class="row col-md-12 nopad">
              <mat-form-field class="col-md-3" appearance="outline">
                <mat-label>Recon Process</mat-label>
                <mat-select name="reconprocess" required (selectionChange)="showRecons($event.value)" [(ngModel)]="reconProcess" [ngModelOptions]="{standalone: true}">
                  <mat-option value="">Select Recon Process</mat-option>
                  <mat-option *ngFor="let recon of reconProcessList" [value]="recon.reconProcess">{{recon.reconProcess}}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="col-md-3" appearance="outline">
                <mat-label>Recon Name</mat-label>
                <mat-select name="reconname" (selectionChange)="showreconId($event.value)" required [(ngModel)]="automail.reconName" [ngModelOptions]="{standalone: true}">
                  <mat-option value="">Select Recon</mat-option>
                  <mat-option *ngFor="let recon of reconList" [value]="recon.reconName">{{recon.reconName}}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="col-md-3" appearance="outline">
                <mat-label>GL Name</mat-label>
                <mat-select name="subrecon" [(ngModel)]="automail.subrecon" [ngModelOptions]="{standalone: true}">
                  <mat-option value="">Option</mat-option>
                  <mat-option *ngFor="let sub_recon of subRecon" [value]="sub_recon" (change)="selectSubrecon($event)">{{sub_recon}}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="col-md-3" appearance="outline">
                <mat-label>Unit Name</mat-label>
                <mat-select name="unit" [(ngModel)]="automail.unit" [ngModelOptions]="{standalone: true}">
                  <mat-option value="">Option</mat-option>
                  <mat-option *ngFor="let unit of unitnames" [value]="unit" >{{unit}}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="col-md-3" appearance="outline">
                <mat-label>Time Delta</mat-label>
                <mat-select  name="deltadate" [(ngModel)]="automail.deltadateSelected" [ngModelOptions]="{standalone: true}">
                  <mat-option value="">Option</mat-option>
                  <mat-option *ngFor="let delta of deltadate" [value]="delta">{{delta}}</mat-option>
                </mat-select>
              </mat-form-field>
              <div class="col-md-3 mr20">
                <mat-form-field class="pl-2" appearance="outline">
                  <mat-select #select1 multiple [(ngModel)]="selectedItems" name="displayname" placeholder="Reports" [ngModelOptions]="{standalone: true}">
                    <mat-select-filter *ngIf="select1.focused" [placeholder]="'Search Report'" [array]="sourceReports" displayMember="displayName" (filteredReturn)="groups=$event"></mat-select-filter>
                    <mat-option [matTooltip]="items.displayName" *ngFor="let items of groups" [value]="items" color="accent">
                      {{items.displayName}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>  

                <!-- <mat-form-field appearance="outline">
                  <mat-label>Reports</mat-label>
                  <mat-select [(ngModel)]="selectedItems" multiple [ngModelOptions]="{standalone: true}">
                    <input matInput class="search-control" [(ngModel)]="searchTxt" placeholder="search">
                    <mat-option [matTooltip]="items.displayName" *ngFor="let items of sourceReports | search : searchTxt" [value]="items">{{items.displayName}}</mat-option>
                  </mat-select>
                </mat-form-field> -->
                <!-- <ng-multiselect-dropdown
                  [placeholder]="'Select report'"
                  [data]="sourceReports"
                  [(ngModel)]="selectedItems"
                  matTooltip=""
                  [ngModelOptions]="{standalone: true}"
                  [settings]="dropdownSettings"
                  (onSelect)="onItemSelect($event)"
                  (onSelectAll)="onSelectAll($event)"
                  (onDeSelect)="onItemDeSelect($event)"
                  (onDeSelectAll)="onDeselectAll($event)">
                </ng-multiselect-dropdown> -->
              </div>
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>Template</mat-label>
                  <mat-select [(ngModel)]="selectedTemplate" [ngModelOptions]="{standalone: true}">
                    <mat-option value="">Select Template</mat-option>
                    <mat-option [value]="item" *ngFor="let item of templateList">{{item}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            
            <div class="row col-md-12">
              <div class="col-md-1">
                <mat-checkbox [checked]="shScheduler" class="row" required (change)="showScheduler($event.checked)"> 
                  Scheduler
                </mat-checkbox>
              </div>
              <mat-form-field appearance="outline" class="col-md-2" *ngIf="shScheduler">
                <mat-label>HH</mat-label>
                <mat-select matNativeControl [(ngModel)]="schedulerObj.hours"  name="schedulerhour" [ngModelOptions]="{standalone: true}">
                  <mat-option value="">Select hour</mat-option>
                  <mat-option *ngFor="let hr of hour" [value]="hr">
                    {{hr}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="col-md-2" *ngIf="shScheduler">
                <mat-label>MM</mat-label>
                <mat-select matNativeControl [(ngModel)]="schedulerObj.minutes" name="schedulermin" [ngModelOptions]="{standalone: true}">
                  <mat-option value="">Choose Minute(s)</mat-option>
                  <mat-option *ngFor="let min of minutes" [value]="min">{{min}}</mat-option>
                </mat-select>
              </mat-form-field>
              <div class="col-md-2">
                <mat-checkbox [checked]="autoTrigger" class="" (change)="Trigger($event)">
                  Auto Trigger
                </mat-checkbox>
              </div>
              <div class="col-md-2 ml10">
                <mat-checkbox [checked]="ageing" class="row" name="ageing" id="ageing" (change)="showAgeing($event)"> 
                  Ageing Configuration
                </mat-checkbox>
              </div>
              <div class="ml-2 mb-2 d-flex flex-row alight-item-center">
                <span class="mr-3">Active</span>
                <mat-slide-toggle name="isActive" id="schrTglBtn" class="" matTooltip="{{isActive}}" [(ngModel)]="isActive">
                </mat-slide-toggle>
              </div>
            </div>
          </form>
        </mat-card>
        <mat-card class="rules-headers-align" *ngIf="enableAgeing" style="position: relative; display: flow-root;">
          <div class="col-md-12">
            <button mat-raised-button (click)="addRow()" class="mb-3 float-right position-absolute r-1p mt--10"><mat-icon>add</mat-icon> Add Row</button>
            <mat-card-header>
              <mat-card-title>Ageing Days</mat-card-title>
            </mat-card-header>
          </div>
          <!-- <table mat-table [dataSource]="dataSource" class="w-100">
            <form [formGroup]="form" action="">
              <ng-container matColumnDef="Display Name">
                <th mat-header-cell *matHeaderCellDef> Display Name </th>
                <td mat-cell *matCellDef="let element"> 
                  <span *ngIf="!element.isEditable">{{element.UIDisplayName}} </span>
                  <mat-form-field appearance="outline" *ngIf="element.isEditable">
                    <mat-label>Select Level</mat-label>
                    <mat-select formControlName="element.UIDisplayName">
                      <mat-option value="">Select level</mat-option>
                      <mat-option *ngFor="let level of listOfLevels" [value]="level">{{level}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </td>
              </ng-container>
              <ng-container matColumnDef="File Column">
                <th mat-header-cell *matHeaderCellDef> File Column </th>
                <td mat-cell *matCellDef="let element">
                  <span *ngIf="!element.isEditable">{{element.fileColumn}}</span> 
                  <mat-form-field *ngIf="element.isEditable">
                    <input matInput type="text" placeholder="" formControlName="element.fileColumn">
                  </mat-form-field>
                </td>
              </ng-container>
              <ng-container matColumnDef="Data Type">
                <th mat-header-cell *matHeaderCellDef> Data Type </th>
                <td mat-cell *matCellDef="let element"> 
                  <span *ngIf="!element.isEditable">{{element.dataType}} </span>
                  <mat-form-field *ngIf="element.isEditable">
                    <mat-select formControlName="element.dataType">
                      <mat-option>Select type</mat-option>
                      <mat-option value="hello">hello</mat-option>
                    </mat-select>
                  </mat-form-field>  
                </td>
              </ng-container>
              <ng-container matColumnDef="Actions">
                <th mat-header-cell *matHeaderCellDef>Action</th>
                <td mat-cell *matCellDef="let element; let i = index">
                  <button *ngIf="!element.isEditable" mat-icon-button color="accent" (click)="editData(element, i)" matTooltip="Edit">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button *ngIf="!element.isEditable" color="warn" mat-icon-button (click)="deleteRuleConfirmationDialog(element, i)" matTooltip="Delete">
                    <mat-icon>delete</mat-icon>
                  </button>
                  <button *ngIf="element.isEditable" color="primary" mat-icon-button (click)="saveFilter(element, i)" matTooltip="Save">
                    <mat-icon>save</mat-icon>
                  </button>
                  <button *ngIf="element.isEditable" color="warn" mat-icon-button (click)="cancel(element, i)" matTooltip="Cancel">
                    <mat-icon>close</mat-icon>
                  </button>
                </td>
              </ng-container>
            </form>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table> -->
          <div *ngIf="enableAgeing">
            <form #mailertable="ngForm" class="mb10">
              <table mat-table #tableData [dataSource]="dataSource" class="w-100 mat-elevation-z8">
                <ng-container matColumnDef="level">
                  <th mat-header-cell *matHeaderCellDef> Level </th>
                  <td mat-cell *matCellDef="let element"> 
                    <mat-form-field color="warn" appearance="outline">
                      <mat-label>Select Level</mat-label>
                      <mat-select name="escLevel{{element.id}}" required [(ngModel)]="element.escLevel" placeholder="Level" id="escLevel{{element.id}}">
                        <mat-option *ngFor="let level of listOfLevels; let i = index" [value]="level">
                              {{level}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </td>
                </ng-container>
              
                <!-- Name Column  (selectionChange)="showreconId($event.value)" name="reconname" [(ngModel)]="reconname"-->
                <ng-container matColumnDef="ageingdays">
                  <th mat-header-cell *matHeaderCellDef> Ageing Days </th>
                  <td mat-cell *matCellDef="let element"> 
                    <mat-form-field appearance="outline" class="col-md-5">
                      <mat-label>Ageing Start Date</mat-label>
                      <!-- <mat-select [(ngModel)]="element.ageingstart" required name="ageingstart{{element.id}}" id="ageingstart{{element.id}}">
                        <mat-option value="">Select Range</mat-option>
                        <mat-option [value]="days" *ngFor="let days of ageingDate">{{days}}</mat-option>
                      </mat-select> -->
                      <input matInput #to type="number" [(ngModel)]="element.ageingstart" required name="ageingstart{{element.id}}" id="ageingstart{{element.id}}">
                    </mat-form-field>
                    <mat-form-field color="warn" class="col-md-5" appearance="outline">
                      <mat-label>Agieng End Date</mat-label>
                    <!-- <mat-select [(ngModel)]="element.ageingend" required name="ageingend{{element.id}}" id="ageingend{{element.id}}">
                      <mat-option value="option">Option</mat-option>
                      <mat-option [value]="days" *ngFor="let days of month">{{days}}</mat-option>
                    </mat-select> -->
                      <input matInput #to type="number" [(ngModel)]="element.ageingend" required name="ageingend{{element.id}}" id="ageingend{{element.id}}">
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="to">
                  <th mat-header-cell *matHeaderCellDef> To </th>
                  <td mat-cell *matCellDef="let element"> 
                    <mat-form-field>
                      <mat-label>To</mat-label>
                      <input matInput #to type="email" name="mailTo{{element.id}}" required id="mailTo{{element.id}}" [(ngModel)]="element.mailTo">
                      <mat-hint>e-mail ID</mat-hint>
                    </mat-form-field>
                  </td>
                </ng-container>
              
                <!-- Symbol Column -->
                <ng-container matColumnDef="cc">
                  <th mat-header-cell *matHeaderCellDef> Cc </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-form-field><mat-label>Cc</mat-label>
                    <input matInput type="email" name="cc{{element.id}}" required id="cc{{element.id}}" [(ngModel)]="element.cc" #cc>
                    <mat-hint>Cc to e-mail ID</mat-hint>
                  </mat-form-field>  </td>
                </ng-container>
            
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef>Actions </th>
                  <td mat-cell *matCellDef="let element"> 
                    <button mat-icon-button type="submit" (click)="getRecord(element,'check')">
                      <mat-icon class="mat-18">check_circle</mat-icon>
                    </button>
                    <button mat-icon-button (click)="getRecord(element, 'delete')">
                      <mat-icon class="mat-18">delete</mat-icon>
                    </button>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index" ></tr>
              </table>
            </form>
            <!-- [disabled]="mailerform.form.valid"  -->
            <div class="float-right mt-20"> 
              <!-- *ngIf="editSave" -->
              <button *ngIf="!editUpdate" mat-raised-button color="primary" type="submit" [disabled]="!mailertable.form.valid && !mailerForm.form.valid"  (click)="SaveData(mailerForm.value, mailertable.value)" 
              class="spacing mr-3">Save</button>
              <button *ngIf="editUpdate" mat-raised-button color="primary" type="submit" [disabled]="!mailerForm.form.valid && !mailertable.form.valid" (click)="updateRecord(mailerForm.value, mailertable.value, rowData)" 
                class="spacing">Update</button>
              <button mat-raised-button color="default" (click)="close(); addEdit = !addEdit" class="spacing">Close</button>
            </div>
          </div>
        </mat-card>
      </mat-card-content>
    </mat-card>
  </ng-container>

  <s-modal id="autoTriggerStmtDate">
    <mat-card class="modal" style="width: 500px">
    <button class="float-right" mat-icon-button aria-label="close modal icon" matTooltip="Close"
            (click)="modalService.close('autoTriggerStmtDate');" id="empwdAppBtn">
        <mat-icon>close</mat-icon>
    </button>
    <mat-card-header>
        <mat-card-title>Statement Date</mat-card-title>
    </mat-card-header>
    <mat-card-content class="mat-dialog-content">
        <mat-card class="p-10" mat-card style="width:90%; position: relative; display: inline-block;">
            <h3 class="row">Select</h3>
            <mat-form-field class="datePick">
              <input matInput [matDatepicker]="sdate" [max]="today" placeholder="Statement Date"
                  [(ngModel)]="statementDate"
                  (dateChange)="getStatementDate($event)">
              <mat-datepicker-toggle matSuffix [for]="sdate"></mat-datepicker-toggle>
              <mat-datepicker #sdate disabled="false"></mat-datepicker>
          </mat-form-field>
        </mat-card>
    </mat-card-content>
    <div class="mat-dialog-actions mt10">
        <button mat-raised-button color="primary" class="mr20" (click)="confirmTrigger()">Send Mail</button>
        <button type="button" mat-button (click)="modalService.close('autoTriggerStmtDate');" id="empwdAppBtn">Close</button>
    </div>
    </mat-card>
  </s-modal>
